import { defineStore } from "pinia";
import { useCurationExperienceStore } from "@/features/experience-curation/stores/useCurationExperienceStore";
import { areNonCommercialFieldsEditableForUser } from "@/features/experience-curation/lib/viewTypeUtils";
import { useCurrentExperienceVenuesQuery } from "@/features/experience-shared/queries/useExperienceVenuesQuery";
import { useHasFunctionalFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";
import { useVenuesField } from "@/features/experience-shared/composables/location/useVenuesField";
import { useCurationCity } from "../city/useCurationCity";
import { useCurationAdditionalCities } from "../additional-cities/useCurationAdditionalCities";

export const useCurationVenues = defineStore("curation-location-venues-field", () => {
  const curationExperienceStore = useCurationExperienceStore();
  const venuesQuery = useCurrentExperienceVenuesQuery();
  const cityStore = useCurationCity();
  const additionalCitiesStore = useCurationAdditionalCities();

  const initialValue = computed<string[]>(() => venuesQuery.data.value?.venues ?? []);
  const cityModel = computed(() => cityStore.model);
  const additionalCitiesModel = computed(() => additionalCitiesStore.model);

  const field = useVenuesField(initialValue, cityModel, additionalCitiesModel);

  const isReadonly = computed(() => curationExperienceStore.isReadonly || !areNonCommercialFieldsEditableForUser());
  const isVisible = computed(() => !curationExperienceStore.isCommercialView);
  const hasUnpublishedChange = useHasFunctionalFieldChange("venues");

  return { ...field, isReadonly, isVisible, hasUnpublishedChange };
});
